<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <v-container class="whitesmoke pa-0">
        <v-row class="whitesmoke tab" no-gutters>
            <v-alert
                v-if="device?.data?.properties?.ot?.domx === undefined"
                color="error"
                class="mx-1"
                dense
                outlined
                icon="mdi-alert-circle-outline"
                type="error"
                >
                {{$t('comboNoData')}}
            </v-alert>
        </v-row>
        <v-row v-if="device?.data?.properties?.ot?.domx !== undefined" class="whitesmoke tab" no-gutters>
            <v-alert
            v-if="rfCommunicationLost"
            color="error"
            class="mx-1"
            dense
            outlined
            icon="mdi-alert-circle-outline"
            type="error"
            >
            {{$t('rf_communication_error')}}
            </v-alert>
            <v-alert
            v-if="boilerFault"
            color="orange"
            class="mx-1"
            dense
            outlined
            icon="mdi-alert-outline"
            type="warning"
            >
            {{$t('boiler_error')}}
            </v-alert>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.domx.otc_cur !== undefined && device?.data?.properties?.ot?.domx.bypass == 1"
                :title="$t('heating_balance')"
                :title_number="device?.data?.properties?.ot?.domx.otc_cur?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-chart-line-variant"
                card_icon_color="cyan"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.domx.cloud_blr !== undefined && !(device?.data?.properties?.ot?.domx.bypass == 1)"
                :title="$t('fixed_boiler_temperature')"
                :title_number="device?.data?.properties?.ot?.domx.cloud_blr?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-chart-line-variant"
                card_icon_color="cyan"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.domx.t_r !== undefined"
                :title="$t('indoor_temperature')"
                :title_number="device?.data?.properties?.ot?.domx.t_r?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-home"
                unit="celsius"
                card_icon_color="green"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.domx.t_r_set !== undefined"
                :title="$t('room_target')"
                :title_number="device?.data?.properties?.ot?.domx.t_r_set?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-home-thermometer"
                unit="celsius"
                card_icon_color="cyan"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.domx.t_out !== undefined"
                :title="$t('outdoor_temperature')"
                :title_number="device?.data?.properties?.ot?.domx.t_out?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-cloud"
                unit="celsius"
                card_icon_color="blue"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.boiler.blr_t !== undefined"
                :title="$t('boiler_temperature')"
                :title_number="device?.data?.properties?.ot?.boiler.blr_t?.toFixed(1)"
                :subTitle="$t('target') + ': ' + device?.data?.properties?.ot?.domx.t_set?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-radiator"
                unit="celsius"
                card_icon_color="red"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.boiler.dhw_t !== undefined"
                :title="$t('max_hot_water_temperature')"
                :title_number="device?.data?.properties?.ot?.boiler.dhw_t?.toFixed(1)"
                :subTitle="$t('target') + ': ' + device?.data?.properties?.ot?.domx.t_dhw_set?.toFixed(1)"
                text_font_size="20px"
                card_icon="mdi-water"
                unit="celsius"
                card_icon_color="blue"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.boiler.ch_pres !== undefined"
                :title="$t('ch_pres')"
                :title_number="device?.data?.properties?.ot?.boiler.ch_pres?.toFixed(1)"
                text_font_size="20px"
                unit="bar"
                card_icon="mdi-gauge-low"
                card_icon_color="magenta"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.boiler.heat !== undefined"
                :title="$t('circulator')"
                :title_number="device?.data?.properties?.ot?.boiler.heat ? 'ON' : 'OFF'"
                text_font_size="20px"
                :card_icon="device?.data?.properties?.ot?.boiler.heat ? 'mdi-pump' : 'mdi-pump-off'"
                card_icon_color="green"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.boiler.water !== undefined"
                :title="$t('water')"
                :title_number="device?.data?.properties?.ot?.boiler.water ? 'ON' : 'OFF'"
                text_font_size="20px"
                :card_icon="device?.data?.properties?.ot?.boiler.water ? 'mdi-water-pump' : 'mdi-water-pump-off'"
                card_icon_color="yellow"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.boiler.flame !== undefined"
                :title="$t('flame')"
                :title_number="device?.data?.properties?.ot?.boiler.flame ? 'ON' : 'OFF'"
                text_font_size="20px"
                :card_icon="device?.data?.properties?.ot?.boiler.flame ? 'mdi-fire' : 'mdi-fire-off'"
                card_icon_color="red"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.domx.relay !== undefined"
                :title="$t('relay')"
                :title_number="device?.data?.properties?.ot?.domx.relay ? 'ON' : 'OFF'"
                text_font_size="20px"
                :card_icon="device?.data?.properties?.ot?.domx.relay ? 'mdi-electric-switch-closed' : 'mdi-electric-switch'"
                card_icon_color="gray"
            ></DeviceOverviewCard>
            <DeviceOverviewCard
                v-if="device?.data?.properties?.ot?.boiler.fault !== undefined"
                :title="$t('boiler_status')"
                :title_number="''"
                text_font_size="20px"
                :card_icon="device?.data?.properties?.ot?.boiler.fault ? 'mdi-alert-outline' : 'mdi-heart'"
                :card_icon_color="device?.data?.properties?.ot?.boiler.fault ? 'warning' : 'green'"
            ></DeviceOverviewCard>
        </v-row>
    </v-container>

</template>


<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import DashboardCardBarChart from "@/components/Cards/DashboardCardBarChart.vue";
import DashboardCardPieChart from "@/components/Cards/DashboardCardPieChart.vue";
import DeviceOverviewCard from "@/components/Cards/DeviceOverviewCard.vue";
import DeviceOverviewSwitchCard from "@/components/Cards/DeviceOverviewSwitchCard.vue";
import DeviceOverviewButtonCard from "@/components/Cards/DeviceOverviewButtonCard.vue";
import DeviceOverviewHeatingBalanceSliderCard from "@/components/Cards/DeviceOverviewHeatingBalanceSliderCard.vue";
import DashboardCardFaultsPieChart from "@/components/Cards/DashboardCardFaultsPieChart.vue";
import DeviceOverviewRoomTargetCard from "@/components/Cards/DeviceOverviewRoomTargetCard.vue";
import dayjs from 'dayjs';

@Component({
  components: {
    DashboardCardBarChart,
    DashboardCardPieChart,
    DeviceOverviewCard,
    DeviceOverviewSwitchCard,
    DeviceOverviewButtonCard,
    DeviceOverviewHeatingBalanceSliderCard,
    DeviceOverviewRoomTargetCard,
    DashboardCardFaultsPieChart,
  }
})

export default class HeatingControllerGeneralView extends Vue {
 @Prop() device: Record<string, any>;

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  get rfCommunicationLost() {
    if( (dayjs(this.device.data.properties?.ot?.rf?.time) < dayjs().subtract(2,'hours'))  && this.device.data.onlineState) {
        return true;
    }
    return false;
  }

  get dataUnavailable() {
    return this.device?.data?.properties?.ot?.domx === undefined 
  }

  get boilerFault() {
    return this.device.data.properties?.ot?.boiler?.fault > 0;
  }

};
</script>

<style scoped lang="scss">
.tab {
  max-height: calc(80vh - 230px) !important;
  overflow-y: auto;
}

div { 
    width:100%;
}
</style>
